<ng-container *transloco="let t">
  <div class="w-[30rem]">
    @if (isEmailRegistered() === false && email.valid) {
      <div class="mb-4">
        <IAlert [title]="t('manage-authorized-access-modal.email_description')" />
      </div>
    }
    <form id="email-form" name="email-form" [formGroup]="emailForm">
      <IInput
        [label]="t('common.email')"
        placeholder="email@example.com"
        [control]="emailForm.controls.email"
        [error]="emailForm.controls.email.errors?.['email'] ? t('register.email_invalid_error') : null"
        size="sm"
        autoFocus
      />
    </form>
    <div class="flex justify-end gap-2 pt-4">
      <IButton [label]="t('common.cancel')" color="white" (onClick)="modalRef.close()" size="sm" />
      <IButton
        [label]="buttonLabel()"
        [loading]="checkEmailLoading() || addAdminLoading()"
        (onClick)="addAdmin()"
        [disabled]="email.invalid"
        size="sm"
      />
    </div>
  </div>
</ng-container>
